module.exports = __webpack_public_path__ + "img/Villa_Borna_37.3e3cbbbd.jpg";